import visa from "../imagenes/VisaColor.png";
import american from "../imagenes/AmericanEx.png";
import master from "../imagenes/MasterCard.png";
import diners from "../imagenes/Diners-Club.png";

// eslint-disable-next-line import/no-anonymous-default-export

export default {
  visa,
  american,
  master,
  diners,
};
